import { createModelsCarouselFaConfig } from './create-models-carousel-fa-config';
import { defaultAppConfig } from './default-app-config';
import { FeatureAppNames } from './app-constants';
import { ModelsCarouselIntegratorOptions } from './create-options-from-query-params';

const getCreateFunctionInstance = (featureAppName: string | undefined) => {
  switch (featureAppName) {
    case FeatureAppNames.DEFAULT as string:
      return defaultAppConfig.createFunctionInstance;
    default:
      return createModelsCarouselFaConfig;
  }
};

export const getConfigsFeatureApp = ({
  featureAppName,
  ...props
}: ModelsCarouselIntegratorOptions) => {
  const createFunctionInstance = getCreateFunctionInstance(featureAppName);
  return createFunctionInstance(props);
};

export const contentFeatureAppMap = {
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appContent,
};
